import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08bdc920&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=08bdc920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bdc920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bdc920')) {
      api.createRecord('08bdc920', component.options)
    } else {
      api.reload('08bdc920', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08bdc920&scoped=true&", function () {
      api.rerender('08bdc920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/analytics/index.vue"
export default component.exports